import * as React from 'react';
import PropTypes from 'prop-types';
import { Row } from 'antd';
import i18n from 'i18n-react';
import Button from '../../../../components/button/Button';

import './FlightChangeFooter.css';

const propTypes = {
  isSelectedOrigin: PropTypes.bool.isRequired,
  isSelectedDestiny: PropTypes.bool.isRequired,
  handleChangeFlightSelect: PropTypes.any
};

class FlightChangeSelectionFooter extends React.Component {
  render() {
    return (
      <Row className=" FlightChangeFooter">
        <Button
          name="cancelTrip"
          className="text-xl HeaderPNRTrackerContainer__cancelTrip"
          background="navy-blue margin-eight-top-8"
          disabled={!this.props.isSelectedOrigin && !this.props.isSelectedDestiny}
          onClick={() => this.props.handleChangeFlightSelect()}>
          {i18n.translate('features.flightChange.continue')}
        </Button>
      </Row>
    );
  }
}

FlightChangeSelectionFooter.propTypes = propTypes;

export default FlightChangeSelectionFooter;



// WEBPACK FOOTER //
// ./src/page/flightChangeSelection/components/FlightChangeSelectionFooter/index.jsx